<template>
  <div>
    <b-card no-body>
      <div slot="header">
        <div>
          <b-row>
            <b-col cols="6" class="d-flex align-items-center">
              <div class="float-left">
                <strong>{{title}}</strong>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="float-right">
                <b-button v-if="allowCollapse && items.length" @click="toggle"
                  :class="items.length > 0 ? 'btn-success ml-2' : 'btn-lightgray ml-2'">
                  <i :class="isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-collapse :visible="searchTableCollapsed" class="card-padding">
        <div v-if="isLoading" class="text-center text-danger my-2 p-3">
          <b-spinner class="align-middle" variant="primary"></b-spinner>
          <strong class="m-2 text-primary">{{ $lang.textLoding }}</strong>
        </div>
        <div class="table-responsive">
          <table v-if="!isLoading" class="table border">
            <thead>
              <tr>
                <th scope="col">تمرین قبلی پیش نیاز</th>
                <th scope="col">نام تمرین </th>
                <th scope="col">پیش نیاز</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in  items" :key="index" button :disabled="index ==0">
                <th scope="row">
                  <div :class="`float-left ${index ==0 ? `d-none` :``}`">
                    <b-form-checkbox :disabled="parentPermissions.includes('view')" @change="itemSelected(item,$event)"
                      :id="`box-${index}`" :checked="item[valueChecked]" v-model="item[valueChecked]"
                      :name="`box-${index}`">
                    </b-form-checkbox>
                  </div>
                </th>

                <td> {{item[text]}}</td>
                <td>
                  <span v-if="item[valueChecked]">{{items[index-1][text]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </b-collapse>

    </b-card>

  </div>
</template>

<script>
  export default {
    name: "",
    props: {
      title: {
        type: String,
        default: ""
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: "id"
      },
      text: {
        type: String,
        default: "name"
      },
      allowCollapse: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default: () => []
      },
      valueChecked: {
        type: String,
        default: "enable"
      },
      parentPermissions: {
        type: Array,
        default: () => []
      }
    },
    computed: {
       searchTableCollapsed() {
        if (this.allowCollapse && !this.isCollapsed) return false;
        else return true;
      },
    },
    data() {
      return {
        isCollapsed: false,
        // items: [{
        //     caption: "Button item",
        //     checked: true
        //   },
        //   {
        //     caption: "  I accept the terms and use",
        //     checked: true
        //   },
        //   {
        //     caption: "  I accept the terms and use",
        //     checked: true
        //   }
        // ]
      }
    },
    methods: {
      toggle() {
        this.isCollapsed = !this.isCollapsed
      },
      itemSelected(item, event) {
        this.$emit("itemSelected", item, event)
      }
    }
  }

</script>

<style>
  .card-padding {
    padding: 1.25rem;
  }

</style>
